<template>
  <div id="entradas-bloqueadas" style="margin-top: 10px" class="w3-container">
    <div class="w3-row-padding row-entradas-bloqueadas">
      <div v-if="!processando" class="w3-margin-bottom">
        <input 
          class="w3-input w3-border w3-padding margin-bottom-filtro"
          type="text"
          placeholder="Pesquise por nome ou código"
          v-model="filtro"
          v-on:keyup="filtrarEntradas()">
      </div>

      <div 
        class="w3-panel w3-text-theme w3-bottombar w3-border-theme w3-border w3-animate-left" 
        v-if="!processando && ((!entradas_bloqueadas) || (entradas_bloqueadas.length == 0))"
        v-cloak>

        <div class="w3-container w3-white">
          <p>Não há entradas a serem exibidas.</p>
        </div>
      </div>
        
      <div v-cloak class="w3-panel w3-theme w3-card" v-if="processando">
        <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
      </div>
        
      <div 
        class="card-item w3-container"
        v-for="(entrada, entrada_index) in novasEntradasBloqueadasFiltradas" 
        :key="entrada_index"
        v-cloak>
  
        <div class="w3-container w3-white">        
          <div class="w3-third">
            <label>Data da entrada: </label>
            <strong>{{entrada.data_entrada}}</strong>
          </div>
          
          <div class="w3-third">
            <label>Entrada: </label>
            <strong>{{entrada.entrada_id}}</strong>
          </div>
          
          <div class="w3-third">
            <label>Fornecedor: </label>
            <strong>{{entrada.nome_fornecedor}}</strong>
          </div>
          
          <div class="w3-third">
            <label>Número da nota: </label>
            <strong>{{entrada.numero_nota}}</strong>
          </div>
          
          <div class="w3-third">
            <label>Status analítico: </label>
            <strong>{{entrada.status_analitico}}</strong>
          </div>
          
          <div class="w3-third">
            <label>Empresa: </label>
            <strong>{{entrada.nome_empresa}}</strong>
          </div>

          <div
            class="divTabelaBloqueios conteudo-centralizado w3-margin-top w3-margin-bottom"
            v-if="entrada.motivos_bloqueio.length > 0">

            <div 
              class="card-item w3-container"
              v-for="(motivo, motivo_index) in entrada.motivos_bloqueio"
              :key="motivo_index"
              v-cloak>

              <div class="w3-left-align">
                <strong>Tipo de Bloqueio Analítico: </strong>
                <label>{{motivo.tipo_trava_analitico}}</label>
              </div>

              <div class="w3-left-align" style="margin-top: 10px;">
                <strong>Informação Adicional: </strong>
                <label>{{motivo.informacao_adicional}}</label>
              </div>

              <div class="w3-left-align" style="margin-top: 10px;">
                <strong>Motivo: </strong>
                <label>{{motivo.motivo}}</label>
              </div>
            </div>
          </div>

          <div class="w3-row">
            <div class="divBotoesLiberar conteudo-centralizado" style="margin-bottom:5px"> 
              <button 
                class="btn-liberar w3-button w3-green"
                @click.prevent="liberarEntrada(entrada.entrada_id)">
                <i class="fa fa-lock-open w3-center"/>
                Liberar entrada
              </button>
              
              <button 
                class="btn-voltar-orcamento w3-button w3-border w3-red"
                @click.prevent="recusarEntrada(entrada.entrada_id)">
                <i class="fa fa-hand-paper w3-center"/>
                Recusar entrada
              </button>
            </div>
          </div>

        </div>
        <hr>
      </div>

      <paginacao 
        @pagina="mudarPagina" 
        :pagina-atual="pagina_atual" 
        :itens-por-pagina="itens_por_pagina"
        :total-resultados="total_resultados" 
        :total-de-paginas="total_de_paginas"/>

    </div>
  </div>
</template>

<script>
  import toastr from 'toastr'
  import Paginacao from '@/components/Paginacao'
  import REntradaBuscarEntradasBloqueadasDashboard from '@/components/Rest/REntrada/REntradaBuscarEntradasBloqueadasDashboard.js'
  import REntradaVoltarEntradaBloqueada from '@/components/Rest/REntrada/REntradaVoltarEntradaBloqueada.js'
  import REntradaLiberarEntradaBloqueada from '@/components/Rest/REntrada/REntradaLiberarEntradaBloqueada.js'
  
  export default {
    name: 'EntradasBloqueadas',

    props: ['empresasIds'],

    components: {
      Paginacao
    },

    data() {
      const self = this;

      return {
        filtro: '',
        processando: false,
        entradas_filtradas: [],
        entradas_bloqueadas: [],

        pagina_atual: 0,
        total_resultados: 0,
        total_de_paginas: 0,
        itens_por_pagina: 10
      }
    },

    methods: {
      mudarPagina(numeroDaPagina) {
        this.pagina_atual = numeroDaPagina;
      },

      filtrarEntradas() {
        this.entradas_filtradas = [];
        this.mudarPagina(0)

        if (this.filtro == '') {
          this.entradas_filtradas = this.entradas_bloqueadas;
        }

        for (let i = 0; i < this.entradas_bloqueadas.length; i++) {
          if (this.entradas_bloqueadas[i].nome_fornecedor.toUpperCase().indexOf(this.filtro.toUpperCase()) > -1){
            this.entradas_filtradas.push(this.entradas_bloqueadas[i]);
          }

          if (this.entradas_bloqueadas[i].entrada_id.replace('.', '').indexOf(this.filtro) > -1) {
            this.entradas_filtradas.push(this.entradas_bloqueadas[i]);
          }
        }
      },

      async buscarEntradas() {
        this.processando = true;
        this.entradas_bloqueadas = []; 
        this.entradas_bloqueadas_filtradas = [];

        try {          
          let parametros = {
            empresas_ids: this.empresasIds
          }

          let retorno = await REntradaBuscarEntradasBloqueadasDashboard.buscarEntradasBloqueadasDashboard(this.axios, parametros);
          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          this.entradas_bloqueadas = JSON.parse(JSON.stringify(retorno.dados));
          this.entradas_filtradas = JSON.parse(JSON.stringify(retorno.dados));
          this.processando = false;
        }
        catch (error) {
          toastr.error(error.message);
          this.processando = false;
        }
      },

      liberarEntrada(entrada_id) {
        const self = this;

        swal(
          {
            title: 'Confirmação de liberação de entradas',
            className: 'modalliberarEntrada',
            buttons: ['Cancelar', 'Confirmar'],
            showCloseButton: true,
            text: 'Observações das liberações',
            focusConfirm: false,
            content: {
              element: 'textarea',
              attributes: {
                rows: 3,
                class: 'w3-input w3-block w3-border',
              }
            }
          }
        )
        .then (
          async (isConfirm, inputValue) => {
            let textarea = document.querySelector('.modalliberarEntrada .swal-content__textarea').value;
            if (!isConfirm) {
              return false
            }

            try {
              let parametros = {
                entrada_id: entrada_id,
                observacao: textarea
              }

              let retorno = await REntradaLiberarEntradaBloqueada.liberarEntradaBloqueada(this.axios, parametros);
              if (retorno.houve_erro != 'N') {
                throw new Error(retorno.mensagem);
              }

              toastr.success(retorno.dados.mensagem);

              await this.buscarEntradas();
              self.$emit('liberarRecusarEntrada');
            }
            catch (error) {
              toastr.error(error.message);
            }
          }
        )
      },

      recusarEntrada(entrada_id) {
        const self = this;

        swal(
          {
            title: 'Confirmação de recusa de entradas',
            className: 'modalRecusarEntrada',
            buttons: ['Cancelar', 'Confirmar'],
            showCloseButton: true,
            text: 'Essa entrada possui contagem. Ao voltar a entrada a contagem será deletada. Deseja continuar?',
            focusConfirm: false,
          }
        )
        .then(
          async (isConfirm, inputValue) => {
            if (!isConfirm) {
              return false;
            }

            try {
              let parametros = {
                entrada_id: entrada_id
              }

              let retorno = await REntradaVoltarEntradaBloqueada.voltarEntradaBloqueada(this.axios, parametros);
              if (retorno.houve_erro != 'N') {
                throw new Error(retorno.mensagem);
              }

              toastr.success('Entrada retornada com sucesso.');

              await this.buscarEntradas();
              self.$emit('liberarRecusarEntrada');
            } 
            catch (error) {
              toastr.error(error.message);
            }
          }
        );
      }
    },

    mounted() {
      $('html,body').stop().animate(
        {scrollTop: 0}, 
        'slow', 
        'swing'
      );
    },

    computed: {
      novasEntradasBloqueadasFiltradas() {
        this.total_resultados = this.entradas_filtradas.length;
        this.total_de_paginas =  Math.ceil(this.total_resultados / this.itens_por_pagina);
        
        if (this.pagina_atual >= this.total_de_paginas) { 
          this.pagina_atual = this.total_de_paginas;
        }

        let index = this.pagina_atual * this.itens_por_pagina;
        if (this.total_resultados > this.itens_por_pagina) {
          return this.entradas_filtradas.slice(index, index + this.itens_por_pagina);
        } 
        else {
          return this.entradas_filtradas;
        }
      }
    },

    created() {
      this.buscarEntradas();
    }
  }
</script>

<style scoped>
  .card-item {
    background: #fff(235, 235, 235);
    border-radius: 10px;
    margin-bottom: 12px;
    padding: 5px !important;
    border: 2px solid #ccc;
    box-shadow: #ccc 2px 2px 5px 2px;
  }

  .w3-modal-content {
    margin: 0 !important;
    transform: translateX(50%);
  }

  .divTabelaBloqueios {
    width: 100%;
    float: left;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/EntradasBloqueadas.vue